import React from 'react';
import Box from '@mui/material/Box';

import OrganizationChip from 'components/OrganizationChip';
import { mediumGray } from 'utils/color-styles';
import { Modal, ModalContents, ModalTitle } from 'components/Modal/Modal';
import { BackButton } from 'retired/BackButtonLayout/BackButton';

import { CommunityFull } from '../types';

export const PartnersModal = ({
  onClickClose,
  partners,
}: {
  onClickClose: () => void;
  partners: CommunityFull['Nonprofits'];
}) => {
  if (!partners?.length) {
    return null;
  }
  return (
    <Modal open fullWidth onClose={onClickClose}>
      <ModalContents
        onClickClose={onClickClose}
        body={
          <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <BackButton onClick={onClickClose} />
              <ModalTitle style={{ marginBottom: 0, marginLeft: 12 }}>
                Partner Organizations ({partners.length})
              </ModalTitle>
            </div>
            <Box paddingTop={4}>
              {partners.map((nonprofit) => (
                <div
                  key={nonprofit.id}
                  style={{
                    paddingTop: 12,
                    borderBottom: `1px solid ${mediumGray}`,
                  }}
                >
                  <OrganizationChip organization={nonprofit} />
                </div>
              ))}
            </Box>
          </div>
        }
      />
    </Modal>
  );
};
